import { render } from "./ModalsContainer.vue?vue&type=template&id=48dd9365"
import script from "./ModalsContainer.vue?vue&type=script&lang=js"
export * from "./ModalsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__